import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    minHeight: 350,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 0,
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
};

export default function ViewMailsModal({
    mailId,
    title,
    description,
    open,
    setOpen,
    handleOpen,
    handleClose,
    fileName,
    sender,
    date,
    handleDownloadAttachment,
    isCertificadoRetencion,
    handleDownloadCertificadoRetention
}) {
    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        {/* Header */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, pb: 1 }}>
                            <Typography id="transition-modal-title" variant="h6" component="h2" sx={{ flex: 1 }}>
                                {title}
                            </Typography>
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    color: (theme) => theme.palette.grey[500],
                                }}
                                size="large"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Divider />
                        {/* Email Info */}
                        <Box sx={{ px: 2, pt: 1 }}>
                            {sender && (
                                <Typography variant="body2" color="text.secondary">
                                    <strong>De:</strong> {sender}
                                </Typography>
                            )}
                            {date && (
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Fecha:</strong> {date}
                                </Typography>
                            )}
                            {isCertificadoRetencion ? (
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Archivo adjunto:</strong>{' '}
                                    <Button
                                        variant="text"
                                        color="primary"
                                        sx={{ fontWeight: 'bold', textTransform: 'none', p: 0, minWidth: 0 }}
                                        onClick={() => handleDownloadCertificadoRetention(mailId)}
                                    >
                                        CertificadoRetencion.pdf
                                    </Button>
                                </Typography>
                            ) : fileName && (
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Archivo adjunto:</strong>{' '}
                                    <Button
                                        variant="text"
                                        color="primary"
                                        sx={{ fontWeight: 'bold', textTransform: 'none', p: 0, minWidth: 0 }}
                                        onClick={() => handleDownloadAttachment(mailId, fileName)}
                                    >
                                        {fileName}
                                    </Button>
                                </Typography>
                            )}
                        </Box>
                        {/* Email Body */}
                        <Box sx={{ px: 2, py: 2, flex: 1, overflowY: 'auto' }}>
                            <Typography id="transition-modal-description" sx={{ whiteSpace: 'pre-line' }}>
                                {description}
                            </Typography>
                        </Box>
                        <Divider />
                        {/* Footer */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2, pt: 1 }}>
                            <Button onClick={handleClose} variant="outlined" color="primary">
                                Ok
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}